(function(){
  'use strict';
  if(window.__YF_IMAGE_PERFORMANCE_V1__) return;
  window.__YF_IMAGE_PERFORMANCE_V1__=true;

  function hydrateImage(img){
    if(!img || img.dataset.yfImageReady==='true') return;
    var srcset=img.getAttribute('data-yf-srcset');
    var src=img.getAttribute('data-yf-src');
    if(srcset) img.setAttribute('srcset',srcset);
    if(src) img.setAttribute('src',src);
    img.removeAttribute('data-yf-srcset');
    img.removeAttribute('data-yf-src');
    img.dataset.yfImageReady='true';
  }
  function hydrateCard(target){
    var card=target && target.closest ? target.closest('.\#product-card') : null;
    if(!card) return;
    card.querySelectorAll('img[data-yf-deferred-image]').forEach(hydrateImage);
  }
  ['pointerover','focusin','touchstart'].forEach(function(name){
    document.addEventListener(name,function(event){ hydrateCard(event.target); },{capture:true,passive:true});
  });
  document.addEventListener('change',function(event){
    if(event.target && event.target.matches && event.target.matches('.\#product-card-swatch-input')) hydrateCard(event.target);
  },true);
})();
